const Unauthorised = () => (
  <div className="text-center pad-top30">Unauthorized</div>
);

export default Unauthorised;
